import PropTypes from 'prop-types'
import {Spacer, Flex, Text, Divider, Skeleton, Box} from '@chakra-ui/react'

const ScreenHeader = ({text}) => (
  <Text as="h2" textStyle="headline3">
    {text}
  </Text>
)

ScreenHeader.propTypes = {
  text: PropTypes.string.isRequired,
}

export const NewScreenHeader = ({text, children}) => (
  <>
    <Flex className="fs-unmask">
      <ScreenHeader text={text} />
      {children && <Spacer />}
      {children}
    </Flex>
    <Divider borderColor="mld.neutral.500" />
  </>
)

NewScreenHeader.defaultProps = {
  children: null,
}

NewScreenHeader.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export const NextScreenHeader = ({text, isLoaded, children, ...props}) => (
  <Box bg="mld.neutral.0" p="md" borderRadius="lg" {...props}>
    <Flex className="fs-unmask" align="center" h="100%">
      <Skeleton isLoaded={isLoaded}>
        <Text as="h2" className="fs-unmask" textStyle="headline3">
          {text}
        </Text>
      </Skeleton>
      {children && <Spacer />}
      {children}
    </Flex>
  </Box>
)

NextScreenHeader.defaultProps = {
  isLoaded: true,
  children: null,
}

NextScreenHeader.propTypes = {
  text: PropTypes.string.isRequired,
  isLoaded: PropTypes.bool,
  children: PropTypes.node,
}

export default ScreenHeader
